export const MS_IN_DAY = 86400000;

export const DEFAULT_BUDGET_AMOUNT = 8200;
export const DEFAULT_BUDGET_DAYS_COUNT = 30;

export const STORAGE_STATE_KEY = 'tzlvt_app_state';
export const STORAGE_IOS_WIDGET_KEY = 'TYAZH_WIDGET_DATA';

export const BASE_URL = 'https://mstryshk.in';
